module.exports = "/assets/data/7a221f4fa38fa532ced5679049451282-OL3.data.json";